'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = exports.match = exports.history = exports.location = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var location = exports.location = _propTypes2.default.shape({
  hash: _propTypes2.default.string.isRequired,
  key: _propTypes2.default.string, // only in createBrowserHistory and createMemoryHistory
  pathname: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.string.isRequired,
  state: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]) // only in createBrowserHistory and createMemoryHistory
});

var history = exports.history = _propTypes2.default.shape({
  action: _propTypes2.default.oneOf(['PUSH', 'REPLACE', 'POP']).isRequired,
  block: _propTypes2.default.func.isRequired,
  canGo: _propTypes2.default.func, // only in createMemoryHistory
  createHref: _propTypes2.default.func.isRequired,
  entries: _propTypes2.default.arrayOf(location), // only in createMemoryHistory
  go: _propTypes2.default.func.isRequired,
  goBack: _propTypes2.default.func.isRequired,
  goForward: _propTypes2.default.func.isRequired,
  index: _propTypes2.default.number, // only in createMemoryHistory
  length: _propTypes2.default.number,
  listen: _propTypes2.default.func.isRequired,
  location: location.isRequired,
  push: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired
});

var match = exports.match = _propTypes2.default.shape({
  isExact: _propTypes2.default.bool,
  params: _propTypes2.default.object.isRequired,
  path: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired
});

var childRoute = _propTypes2.default.shape({
  path: _propTypes2.default.string.isRequired,
  exact: _propTypes2.default.bool,
  component: _propTypes2.default.element.isRequired,
  routes: _propTypes2.default.arrayOf(childRoute)
});

var route = exports.route = _propTypes2.default.shape({
  component: _propTypes2.default.element,
  routes: _propTypes2.default.arrayOf(childRoute)
});

exports.default = {
  location: location,
  history: history,
  match: match,
  route: route
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-prop-types/dist/index.js
// module id = 69
// module chunks = 0